import { PostHogConfig } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { ReactNode } from 'react';

const PostHogProviderWrapper = ({ children }: { children: ReactNode }) => {
  const options: Partial<PostHogConfig> = {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    opt_out_capturing_by_default: import.meta.env.VITE_ENV === 'development',
    advanced_disable_feature_flags_on_first_load: true,
    ui_host: 'https://eu.posthog.com',
    autocapture: {
      css_selector_allowlist: [
        '.ph-eye-button',
        '.ph-reminder-button',
        '.ph-expandable-reminder-button',
        '.ph-narrative-data-enhancer-button',
      ],
    },
  };

  return (
    <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={options}>
      {children}
    </PostHogProvider>
  );
};

export default PostHogProviderWrapper;
